import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  LAYOUTFOUR: {
    path: `${baseRoutes.userBaseRoutes}layout-four`,
  },
};

export default accessRoute;
